// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.0
//   protoc               unknown
// source: common/payload/EmptyRequestPayloadPt.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { ApiResultPayload } from "../model/ApiResultCodePt";

export const protobufPackage = "io.teamsillim.fightbracket.idl.common.payload";

/** 아무 요청도 안 보낼 때 사용 */
export interface EmptyRequestPayload {
}

/** 결과만 응답 할 때 사용 */
export interface EmptyResponsePayload {
  result: ApiResultPayload | undefined;
}

function createBaseEmptyRequestPayload(): EmptyRequestPayload {
  return {};
}

export const EmptyRequestPayload: MessageFns<EmptyRequestPayload> = {
  encode(_: EmptyRequestPayload, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EmptyRequestPayload {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEmptyRequestPayload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): EmptyRequestPayload {
    return {};
  },

  toJSON(_: EmptyRequestPayload): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<EmptyRequestPayload>, I>>(base?: I): EmptyRequestPayload {
    return EmptyRequestPayload.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EmptyRequestPayload>, I>>(_: I): EmptyRequestPayload {
    const message = createBaseEmptyRequestPayload();
    return message;
  },
};

function createBaseEmptyResponsePayload(): EmptyResponsePayload {
  return { result: undefined };
}

export const EmptyResponsePayload: MessageFns<EmptyResponsePayload> = {
  encode(message: EmptyResponsePayload, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.result !== undefined) {
      ApiResultPayload.encode(message.result, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EmptyResponsePayload {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEmptyResponsePayload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.result = ApiResultPayload.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EmptyResponsePayload {
    return { result: isSet(object.result) ? ApiResultPayload.fromJSON(object.result) : undefined };
  },

  toJSON(message: EmptyResponsePayload): unknown {
    const obj: any = {};
    if (message.result !== undefined) {
      obj.result = ApiResultPayload.toJSON(message.result);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<EmptyResponsePayload>, I>>(base?: I): EmptyResponsePayload {
    return EmptyResponsePayload.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EmptyResponsePayload>, I>>(object: I): EmptyResponsePayload {
    const message = createBaseEmptyResponsePayload();
    message.result = (object.result !== undefined && object.result !== null)
      ? ApiResultPayload.fromPartial(object.result)
      : undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
